import { render, staticRenderFns } from "./BeefPolicyList.vue?vue&type=template&id=056d5111&scoped=true"
import script from "./BeefPolicyList.vue?vue&type=script&lang=js"
export * from "./BeefPolicyList.vue?vue&type=script&lang=js"
import style0 from "./BeefPolicyList.vue?vue&type=style&index=0&id=056d5111&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056d5111",
  null
  
)

export default component.exports